// LOGIN
const Login = () => import('~/pages/auth/login')
const Register = () => import('~/pages/auth/register')
const PasswordEmail = () => import('~/pages/auth/password/email')
const PasswordReset = () => import('~/pages/auth/password/reset')

// CONFIGURAÇÕES
const Settings = () => import('~/pages/settings/index')
const SettingsProfile = () => import('~/pages/settings/profile')
const SettingsConfigs = () => import('~/pages/settings/configs')
const SettingsPassword = () => import('~/pages/settings/password')
const SettingsLanguage = () => import('~/pages/settings/language')
const SettingsEmail = () => import('~/pages/settings/email')

// PAGAMENTOS
const BloqueioFaltaPagamento = () => import('~/pages/pagamentos/BloqueioFaltaPagamento')

// HOME
const Home = () => import('~/pages/home/Home')
const ConfigContaUserHome = () => import('~/pages/home/ConfigContaUserHome')

// PACIENTES
const Pacientes = () => import('~/pages/pacientes/Pacientes')
const CrEdPaciente = () => import('~/pages/pacientes/CriarEditar')

// ESCOLAS
const Escolas = () => import('~/pages/escolas/Escolas')
const CrEdEscola = () => import('~/pages/escolas/CriarEditar')
const EscolaDetalhes = () => import('~/pages/escolas/EscolaDetalhes') //Filtrar Todos os Pacientes por escola

// RESPONSAVEIS
const Responsaveis = () => import('~/pages/responsaveis/Responsaveis')
const CrEdResponsavel = () => import('~/pages/responsaveis/CriarEditar')

// TESTES
// <<<<<<< HEAD
const Testes = () => import('~/pages/testes/Testes')
const CriarTeste = () => import('~/pages/testes/CriarTeste')
const EditarTeste = () => import('~/pages/testes/EditarTeste')
const VerTeste = () => import('~/pages/testes/VerTeste')

// const Testes = () => import('~/pages/testes/Testes')
// const CrEdTeste = () => import('~/pages/testes/CriarEditar')
// const VerTeste = () => import('~/pages/testes/VerTeste')
// const Testes = () => import('~/pages/testesP/Testes')
// const CrEdTeste = () => import('~/pages/testesP/CriarEditar')
// const VerTeste = () => import('~/pages/testesP/VerTeste')
// >>>>>>> eb6aa534524f62cfdeb5890f9bdac9a77590ff58

// ATENDIMENTOS
const Atendimentos = () => import('~/pages/atendimentos/Atendimentos')
const FichaPacienteAtend = () => import('~/pages/atendimentos/FichaAtender')

// DOCUMENTOS
const Documentos = () => import('~/pages/documentos/Documentos')
const Documento = () => import('~/pages/documentos/Documento')
const Imprimir = () => import('~/pages/documentos/Imprimir')

// EDITAR USUÁRIO
// const Usuario = () => import('~/pages/usuarios/Usuario')

// PLANOS
const Planos = () => import('~/pages/planos/Planos')

// PAGAMENTOS
const Pagamentos = () => import('~/pages/pagamentos/Pagamentos')

// PAGAMENTO
const Pagamento = () => import('~/pages/pagamentos/pagamento/Pagamento')

// Wizard de Pagamento
const WizardPagamento = () => import('~/pages/pagamentos/wizard-pag/WizardPagamento')
const EnderecoPagamento = () => import('~/pages/pagamentos/wizard-pag/user/Endereco')
const DadosPessoaisPagamento = () => import('~/pages/pagamentos/wizard-pag/user/DadosPessoais')
// boleto
const ImprimirBoleto = () => import('~/pages/pagamentos/wizard-pag/boleto/ImprimirBoleto')
// pix
const PagarPix = () => import('~/pages/pagamentos/wizard-pag/pix/PagarPix')
// debito
const ConclusaoDebito = () => import('~/pages/pagamentos/wizard-pag/debito/ConclusaoDebito')

// crédito
const CartaoCredito = () => import('~/pages/pagamentos/wizard-pag/credito/CartaoCredito')
const ConcluidoCredito = () => import('~/pages/pagamentos/wizard-pag/credito/ConcluidoCredito')

// FINANCEIRO
const Financeiro = () => import('~/pages/financeiro/Financeiro')
const ContasReceber = () => import('~/pages/financeiro/sub-menu/ContasReceber')
const ContasPagar = () => import('~/pages/financeiro/sub-menu/ContasPagar')
const Extrato = () => import('~/pages/financeiro/sub-menu/Extrato')




export default [

  { path: '/login', name: 'login', component: Login },
  // { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  // { path: '/home', name: 'home', component: Home },
  {
    path: '/settings', component: Settings, children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'configs', name: 'settings.configs', component: SettingsConfigs },
      { path: 'password', name: 'settings.password', component: SettingsPassword },
      { path: 'language', name: 'settings.language', component: SettingsLanguage },
      { path: 'email', name: 'settings.email', component: SettingsEmail },
    ]
  },
  { path: '*', component: require('~/pages/errors/404') },

  { path: '/bloqueio', name: 'bloqueio', component: BloqueioFaltaPagamento },
  // { path: '/home', component: Home,  name: 'home'},
  { path: '/', component: Home, name: 'home' },
  // Usuário d
  { path: '/config-conta-user', component: ConfigContaUserHome, name: 'ConfigContaUserHome' },

  //PACIENTES
  {
    path: '/pacientes',
    component: Pacientes,
    name: 'Pacientes'
  },
  {
    path: '/paciente/cadastrar',
    component: CrEdPaciente,
    name: 'CadastrarPaciente'
  },
  {
    path: '/paciente/:id/:acao', //editar
    component: CrEdPaciente,
    name: 'EditarPaciente'
  },

  //ESCOLAS
  {
    path: '/escolas',
    component: Escolas,
    name: 'Escolas'
  },
  {
    path: '/escola/cadastrar',
    component: CrEdEscola,
    name: 'CadastrarEscola'
  },
  {
    path: '/escola/:id/:acao', //editar
    component: CrEdEscola,
    name: 'EditarEscola'
  },
  {
    path: '/escola/:idEscola', //ver pacientes e detalhes de uma escola
    component: EscolaDetalhes,
    name: 'EscolaDetalhes'
  },

  //RESPONSAVEIS
  {
    path: '/responsaveis',
    component: Responsaveis,
    name: 'Responsaveis'
  },
  {
    path: '/responsavel/cadastrar',
    component: CrEdResponsavel,
    name: 'CadastrarResponsavel'
  },
  {
    path: '/responsavel/:id/:acao', //editar
    component: CrEdResponsavel,
    name: 'EditarResponsavel'
  },

  //TESTES
  {
    path: '/testes',
    component: Testes,
    name: 'Testes'
  },
  {
    path: '/teste/cadastrar',
    component: CriarTeste,
    name: 'CriarTeste'
  },
  {
    path: '/teste/:id/editar',
    component: EditarTeste,
    name: 'EditarTeste'
  },
  {
    path: '/teste/:id',
    component: VerTeste,
    name: 'VerTeste'
  },
  //ATENDIMENTOS
  {
    path: '/atendimentos',
    component: Atendimentos,
    name: 'Atendimentos'
  },
  {
    path: '/atendimento/paciente/:id', //id do paciente
    component: FichaPacienteAtend,
    name: 'Atender'
  },

  //Documentos
  {
    path: '/documentos',
    component: Documentos,
    name: 'Documentos',
  },
  // {
  //   path: '/doc_paciente/:nome_doc/:paciente_id',
  //   component: Documento,
  //   name: 'DocumentoPaciente',
  // },
  {
    path: '/imprimir',
    component: Imprimir,
    name: 'Imprimir'
  },

  //USUÁRIO
  // {
  //   path: '/usuario',
  //   component: Usuario,
  //   name: 'Usuario'
  // },
  //PLANOS
  {
    path: '/planos',
    component: Planos,
    name: 'Planos'
  },
  // PAGAMENTOS - pagamentos das mensalidades do sistema
  {
    path: '/pagamentos',
    component: Pagamentos,
    name: 'Pagamentos'
  },
  // PAGAMENTO - pagamento da mensalidade do sistema
  {
    path: '/pagamento/:user_id/:pagamento_id',
    component: Pagamento,
    name: 'Pagamento'
  },
  // WIZARD DE PAGAMENTO - pagamento da mensalidade do sistema
  {
    path: '/pagamento/:user_id/:pagamento_id/wizard',
    component: WizardPagamento,
    children: [
      { path: 'endereco', component: EnderecoPagamento, name: 'WizarPagamento' },
      { path: 'pessoal', component: DadosPessoaisPagamento, name: 'DadosPessoaisPagamento' },
      // boleto
      { path: 'imprimir-boleto', component: ImprimirBoleto, name: 'ImprimirBoleto' },
      // debito
      { path: 'conclusao-debito', component: ConclusaoDebito, name: 'ConclusaoDebito' },
      // pix
      { path: 'pagar-pix', component: PagarPix, name: 'PagarPix' },
      // crédito
      { path: 'cartao-credito', component: CartaoCredito, name: 'CartaoCredito' },
      { path: 'concluido-credito', component: ConcluidoCredito, name: 'ConcluidoCredito', props: true }
    ]
  },
  // FINANCEIRO DO CLIENTE
  {
    path: '/financeiro',
    component: Financeiro,
    children: [
      { path: '/', component: ContasReceber },
      { path: 'contas-a-pagar', component: ContasPagar, name: 'ContasPagar' },
      { path: 'contas-a-receber', component: ContasReceber, name: 'ContasReceber' },
      { path: 'extrato', component: Extrato, name: 'Financeiro' }
    ]
  }


]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js